var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _setup.tid } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-8" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v(_vm._s(_setup.pipelineName))]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-link btn-sm",
              attrs: {
                href: `/#/admin/integrations/runs/manage/${_setup.tid}`,
                type: "button",
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-arrow-left",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Back")]),
            ]
          ),
          _vm._v(" "),
          !_setup.isDeleted
            ? _c(
                "a",
                {
                  staticClass: "btn btn-link btn-sm",
                  attrs: { role: "button" },
                  on: { click: _setup.handleDeleteRunCommandV1 },
                },
                [
                  _c("i", { staticClass: "fa-regular fa-trash-can" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Delete")]),
                ]
              )
            : _c(
                "a",
                {
                  staticClass: "btn btn-link btn-sm",
                  attrs: { role: "button" },
                  on: { click: _setup.handlePermanentDeleteRunCommandV1 },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-remove",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Permanently delete")]),
                ]
              ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-4 col-sm-6 text-right" }),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container" },
      _vm._l(_setup.log, function (line) {
        return _c(
          "div",
          { staticClass: "row", attrs: { title: line.Message } },
          [
            _c("div", { staticClass: "col-3" }, [
              _vm._v(_vm._s(line.OccuredAt)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-9 text-ellipsis" }, [
              _vm._v(_vm._s(line.Message)),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }